import type { InitialValues } from '@lt/widget/components/Cigarette/context';
import { addDays } from 'date-fns';
import { createSelector } from '@reduxjs/toolkit';
import { convertClientDateToServerDate } from 'src/utils/dateUtils';
import { getCurrentUTCDate } from '@lt/components/utils/date';
import {
  getDefaultDeparture,
  getDestinationParams,
} from '../../../../utils/searchParamsUtils';
import { getSearcherData } from './searcher';
import { getHotelData } from './hotel';
import { getSelectedFromCity } from './departures';

/**
 * инициализация дат новой сигареты на странице отеля
 */
export const cigaretteDatepickerSelector = createSelector(
  [getSearcherData],
  (searcher): InitialValues['datepicker'] => {
    if (!searcher?.startDate || !searcher?.nights) return undefined;

    const convertStartDate = getCurrentUTCDate(
      convertClientDateToServerDate(searcher.startDate),
    );

    const leftDateCell = {
      date: convertStartDate,
    };
    const rightDateCell = {
      date: addDays(convertStartDate, searcher.nights),
    };

    const datepicker: InitialValues['datepicker'] = {
      left: leftDateCell,
      right: rightDateCell,
      shift: 0,
      inputFocuses: {
        isStartDateFocus: false,
        isEndDateFocus: false,
      },
    };

    return datepicker;
  },
);

/**
 * инициализация новой сигареты на странице отеля
 */
export const cigaretteValuesSelector = createSelector(
  [
    getSelectedFromCity,
    getSearcherData,
    getHotelData,
    cigaretteDatepickerSelector,
  ],
  (
    selectedFromCity,
    searcher,
    hotel,
    datepicker?: InitialValues['datepicker'],
  ): InitialValues | undefined => {
    if (!searcher || !hotel) return undefined;

    const destination = getDestinationParams({
      hotel,
      city: searcher.from.city,
      country: hotel.country,
      metaregion: null,
    });

    const tourists: InitialValues['tourists'] = {
      adults: searcher.adults,
      kids: searcher.kidsAges,
    };

    const departure: InitialValues['departure'] =
      searcher.from.city.name_en === 'Any'
        ? getDefaultDeparture()
        : {
            id: searcher.from.city.id,
            iso2: searcher.from.city.iso2,
            label: selectedFromCity.nameRu,
            value: selectedFromCity.nameEn,
            selectedLabel: selectedFromCity.nameRuForm2,
          };

    return { destination, datepicker, tourists, departure };
  },
);
